import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EnvironmentService {

  private _environment: string = 'test';
  
  public set environment(v : string) {
    this._environment = v;
    localStorage.setItem('environment', v);
  }
  
  public get environment() : string {
    return this._environment;
  }
  
  constructor() { 
    let fromStorage = localStorage.getItem('environment');
    if (fromStorage) {
      this._environment = fromStorage;
    }
  }
}
